<div class="content container-fluid">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Org Chart</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="#!"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item active">Org Chart</li>
        </ol>
      </nav>
    </div>
  </div>

  <!-- simple tree chart -->
  <!-- <div class="org-chart-wrapper"> -->
  <!-- <div #svgTree id="svg-tree" style="width: 100%; height: 100%"></div> -->
  <!-- </div> -->

  <!-- <h1>tree chart with image</h1> -->

  <!-- <div class="card w-100 h-100">
    <div class="card-body p-0 mt-1"> -->
  <div class="card">
    <div id="svg-tree" class="card-body"></div>
  </div>
  <!-- </div>
  </div> -->
</div>
